import Filter from './Filter'

export default class Direction extends Filter {
    filterComponent = import('@/views/components/filters/compoents/DirectionFilterComponent.vue')

    static CATEGORY_SUBJECT = 'category_subject_id'

    static IS_PRIORITY = 'is_priority'

    static EXEL_GENERATE_ENDPOINT = '/statistics/direction_dc_type_exel'

    fields = {
      [Direction.CATEGORY_SUBJECT]: {
        label: 'Category Subject',
      },
      [Direction.IS_PRIORITY]: {
        label: 'Ustuvor',
      },
    }
}
